import React from "react";
import { object, number } from "prop-types";
import { Link } from "@quintype/components";

import "./podcast-body.m.css";

const podcastLinks = [
  {
    title: "ಆ್ಯಪಲ್ ಪಾಡ್‌ಕಾಸ್ಟ್ ",
    url: "https://podcasts.apple.com/in/podcast/prajavani/id1513809381"
  },
  {
    title: "ಓವರ್‌ಕಾಸ್ಟ್ ಎಫ್ಎಂ ",
    url: "https://overcast.fm/itunes1513809381/prajavani"
  },
  {
    title: "ಪಾಕೆಟ್ ಕಾಸ್ಟ್ಸ್ ",
    url: "https://pca.st/nbsmgzz0"
  },
  {
    title: "ಪಾಡ್‌ಚೇಸರ್ ",
    url: "https://www.podchaser.com/podcasts/prajavani-2104185"
  }
  // {
  //   title: "ಸ್ಪಾಟಿಫೈ",
  //   url: "https://open.spotify.com/show/1sP238hOvftgLOq4NE6dEF"
  // },
  // {
  //   title: "ಗೂಗಲ್ ಪಾಡ್‌ಕಾಸ್ಟ್",
  //   url: "https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy8yMDE0ODcwOC9wb2RjYXN0L3Jzcw=="
  // },
];

const PodcastBody = ({ }) => {
  const podcastSpotifyLink = "https://open.spotify.com/show/1sP238hOvftgLOq4NE6dEF";
  const podcastLink = "https://www.prajavani.net/podcast";

  const linkTag = (title, url) => (
    <Link styleName="link" href={url} target="_blank" rel="noopener noreferrer" key={url}>
      {title}
    </Link>
  );

  return (
    <div styleName="wrapper">
      <div styleName="line1">
        ಪ್ರಜಾವಾಣಿ ಕನ್ನಡ ಧ್ವನಿ ಪಾಡ್‌ಕಾಸ್ಟ್ ಅನ್ನು ಸ್ಪಾಟಿಫೈ ಚಾನೆಲ್‌ನಲ್ಲಿ ಕೇಳಲು
        {linkTag(" ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ ", podcastSpotifyLink)}.
      </div>
      <div styleName="line2">
        ಹಾಗೂ {podcastLinks.map((item) => linkTag(item.title, item.url))} ಚಾನೆಲ್‌ಗಳಲ್ಲಿ ಕೂಡ ನೀವು ಕೇಳಬಹುದು.
      </div>
      <div styleName="line1">
        ಪ್ರಜಾವಾಣಿ ಪಾಡ್‌ಕಾಸ್ಟ್‌ಗಳ ಸಂಪೂರ್ಣ ಸಂಗ್ರಹ
        {linkTag(" ಇಲ್ಲಿದೆ.", podcastLink)}
      </div>
    </div>
  );
};

PodcastBody.propTypes = {
  story: object,
  index: number
};

PodcastBody.propTypes = {
  story: object,
  index: number
};

export default PodcastBody;
